import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react'

import { load } from 'scrivito'

import { NeoDXPInstanceInfo, FeatureFlag } from '@/Data/const'
import { InstanceInfo } from '@/Data/InstanceInfo/InstanceInfoDataItem'

type FeatureFlagContextType = {
  flags: FeatureFlag[] | undefined
  isEnabled: (flag: FeatureFlag) => boolean
}

const FeatureFlagContext = createContext<FeatureFlagContextType>({
  flags: [],
  isEnabled: () => false,
})

export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  const [flags, setFlags] = useState<FeatureFlag[] | undefined>()

  useEffect(() => {
    load(() => InstanceInfo.get(NeoDXPInstanceInfo.FEATURE_FLAGS)).then((f) =>
      setFlags(f as FeatureFlag[]),
    )
  }, [])

  const isEnabled = (flag: FeatureFlag) => {
    return flags?.includes(flag) ?? false
  }

  return (
    <FeatureFlagContext.Provider value={{ flags, isEnabled }}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

export const useFeatureFlags = () => useContext(FeatureFlagContext)
